import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { HomeComponent } from './shared/components/home/home.component';
import { UpcomingTrainingComponent } from './shared/components/upcoming-training/upcoming-training.component';
import { AboutComponent } from './shared/components/about/about.component';
import { EventDetailComponent } from './shared/components/app-event-page/app-event-detail.component';
import { EventResolver } from './resolvers/event.resolver';
import { EventsComponent } from './shared/components/app-events/app-events.component';
import { ContactUsComponent } from './shared/components/contact-us/contact-us.component';
import { LoginComponent } from './shared/components/login/login.component';
import { RegisterComponent } from './shared/components/register/register.component';
import { AuthGuard } from './guards/auth.guard';
import { ShopComponent } from './shared/components/app-shop/app-shop.component';
import { ProductDetailComponent } from './shared/components/app-product-detail/app-product-detail.component';
import { ProductResolver } from './resolvers/product.resolver';
import { CartComponent } from './shared/components/app-cart/app-cart.component';
import { CheckoutComponent } from './shared/components/app-checkout/app-checkout.component';
import { ConfirmationComponent } from './shared/components/app-confirmation/app-confirmation.component';
import { RoleGuard } from './guards/role.guard';
import { UnauthorizedComponent } from './shared/components/app-unauthorized/app-unauthorized.component';

const routes: Routes = [
	{
		path: '',
		component: HomeComponent,
		title: 'Home page'
	},
	{
		path: 'events',
		component: EventsComponent,
		title: 'Events page'
	},
	{
		path: 'shop',
		component: ShopComponent,
		title: 'Shop page'
	},
	{
		path: 'product/:id',
		component: ProductDetailComponent,
		resolve: {
			product: ProductResolver
		},
		title: 'Shop page'
	},
	{
		path: 'event/:id',
		component: EventDetailComponent,
		resolve: {
			event: EventResolver
		},
		title: 'Event detail'
	},
	{
		path: 'upcoming-training',
		component: UpcomingTrainingComponent,
		title: 'Upcoming Training page'
	},
	{
		path: 'about',
		component: AboutComponent,
		title: 'About page',
	},
	{
		path: 'contact-us',
		component: ContactUsComponent,
		title: 'Contact Us'
	},
	{
		path: 'login',
		component: LoginComponent,
		title: 'Login'
	},
	{
		path: 'register',
		component: RegisterComponent,
		title: 'Register'
	},
	{
		path: 'cart',
		component: CartComponent,
		title: 'Cart'
	},
	{
		path: 'checkout',
		component: CheckoutComponent,
		title: 'Checkout'
	},
	{
		path: 'confirmation',
		component: ConfirmationComponent,
		title: 'Order Confirmation'
	},
	{
		path: 'unauthorized',
		component: UnauthorizedComponent,
		title: 'Unauthorized'
	},
	{
		path: 'user',
		canActivate: [RoleGuard, AuthGuard],
		data: {
			roles: ['viewer'],
		},
		loadChildren: () =>
			import('./user/user.module')
				.then(m => m.UserModule),
	},
	{
		path: 'admin',
		canActivate: [RoleGuard, AuthGuard],
		data: {
			roles: ['admin'],
		},
		loadChildren: () =>
			import('./admin/admin.module')
				.then(m => m.AdminModule),
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
